@if (isMobile()) {
    <kui-card-header>
        <ul class="content-card-actions">
            <li (click)="onClosePanel()">
                <kui-icon kui-action name="times"></kui-icon>
            </li>
        </ul>
    </kui-card-header>
}

<kui-accordion class="flex-1">
    @for (filter of filters; track filter.id) {
        <key-filter-section [title]="filter.title" [expanded]="!filter.collapsed">
            @switch (filter.type) {
                @case ("checkbox") {
                    <key-checkbox-filter [config]="filter"></key-checkbox-filter>
                }
                @case ("radio") {
                    <key-radio-filter [config]="filter"></key-radio-filter>
                }
                @case ("tree") {
                    <key-tree-filter [config]="filter"></key-tree-filter>
                }
            }
        </key-filter-section>
    }
</kui-accordion>

@if (showActionFooter) {
    <kui-card-footer>
        <div style="display: flex; gap: 8px; flex: 1;">
                <button kui-button color="secondary"
                    (click)="deleteFilterConfirmation.emit()"
                    [disabled]="disableActions()"
                    [hidden]="hideDeleteAction()">
                        {{ "STATUS.LIST.FILTERS.DELETE" | translate }}</button>
            
                <button kui-button color="secondary"
                    (click)="updateSelectedFilter.emit('edit')"
                    [disabled]="disableActions()"
                    [hidden]="hideUpdateAction()">
                        {{ "STATUS.LIST.FILTERS.UPDATE" | translate }}</button>
        </div>
        <button kui-button color="primary" (click)="updateSelectedFilter.emit('new')" [disabled]="disableActions()">{{ "STATUS.LIST.FILTERS.NEW" | translate }}</button>
    </kui-card-footer>
}

